import { render } from "./TagPhotosProp.vue?vue&type=template&id=fc6e14ea&scoped=true"
import script from "./TagPhotosProp.vue?vue&type=script&lang=js"
export * from "./TagPhotosProp.vue?vue&type=script&lang=js"

import "./TagPhotosProp.vue?vue&type=style&index=0&id=fc6e14ea&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc6e14ea"]])

export default __exports__